import {
  Button,
  IconButton,
  Stack,
  Typography,
  TextField,
} from "@mui/material";
import { IconHome, IconClose } from "components/Icons/Icons";
import HomeTemplate from "pages/HomeTemplate/HomeTemplate";
import { useHistory, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { RadioButtons } from "components/Inputs/RadioButtons/RadioButtons";
import { DatePicker } from "@mui/x-date-pickers";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { maskPhoneNumber, countBusinessDays } from "utils/Masks/Masks";
import dayjs from "dayjs";
import moment from "moment";
import WarningImage from "assets/illustrations/warning.png";
import ClienteService from "services/cliente";
import ConsigazApi from "api/ConsigazApi";
import { toast } from "react-toastify";
import ModalConfirmationEmail from "./ModalConfirmationEmail/ModalConfirmationEmail";

export default function RegisterCancellation() {
  const history = useHistory();
  const location = useLocation();
  const { address } = location.state || {};

  const [phase, setPhase] = useState(1);
  const [hasDoorman, setHasDoorman] = useState("");
  const [itsOut, setItsOut] = useState("");
  const [itsOutDate, setItsOutDate] = useState(null);
  const [occurrence, setOccurrence] = useState(null);
  const [enterQuestion, setEnterQuestion] = useState("");
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");
  const [othersAccess, setOthersAccess] = useState("");
  const [notPossible, setNotPossible] = useState(false);
  const [modalConfirmation, setModalConfirmation] = useState(false);

  const sendMail = () => {
    const { CPFCNPJ } = ClienteService.localEntrega;
    const { [`local-entrega`]: localEntrega } = address;

    ConsigazApi.sendEmailReminder(
      CPFCNPJ,
      localEntrega,
      moment(itsOutDate, "YYYY-MM-DD").format("YYYY-MM-DD")
    ).then(
      () => {
        setModalConfirmation(true);
      },
      () => toast.error("Erro ao enviar o email")
    );
  };

  const handleOrder = () => {
    const { CPFCNPJ, email } = ClienteService.localEntrega;
    const { [`local-entrega`]: localEntrega } = address;

    ConsigazApi.geraOcorrencia(
      null,
      "Cancelamento",
      null,
      null,
      null,
      CPFCNPJ,
      localEntrega,
      {
        email,
        howWillAccess:
          hasDoorman === "NO" && enterQuestion === "others" ? othersAccess : "",
        portariaEletronica: hasDoorman,
        contatoAcesso:
          hasDoorman === "NO" && enterQuestion === "anotherPerson" ? name : "",
        contatoFone:
          hasDoorman === "NO" && enterQuestion === "anotherPerson" ? phone : "",
        moradorNoLocal: enterQuestion === "me" ? "YES" : "NO",
        leavingDate: dayjs(itsOutDate).format("DD/MM/YYYY"),
      }
    ).then(
      ({ Ocorrencia }) => {
        if (Ocorrencia) {
          setOccurrence(Ocorrencia[0]);
          setPhase(4);
        } else toast.error("Não foi possível localizar o número do protocolo");
      },
      (erro) => {
        toast.error(erro || "Erro ao realizar o cancelamento");
      }
    );
  };

  useEffect(() => {
    if (itsOut === "YES") {
      setItsOutDate(moment());
    }
  }, [itsOut]);

  const disableButton = () => {
    if (phase === 1) {
      if (itsOut !== "") {
        if (itsOut === "NO" && !itsOutDate) {
          return false;
        }
        return true;
      }
    }

    if (hasDoorman === "") {
      return false;
    }

    if (hasDoorman === "NO") {
      if (enterQuestion === "anotherPerson") {
        return Boolean(name.trim() && phone.trim());
      }
      if (enterQuestion === "others") {
        return Boolean(othersAccess.trim());
      }
      if (enterQuestion === "me") {
        return true;
      }
    }

    return hasDoorman === "YES";
  };

  return (
    <HomeTemplate history={history}>
      {((phase > 1 && phase < 4) || (phase === 1 && notPossible)) && (
        <Stack alignSelf={"flex-start"} direction={"row"}>
          <IconButton
            onClick={() => {
              if (phase === 1 && notPossible) {
                return setNotPossible(false);
              }

              setPhase((prev) => prev - 1);
            }}
            sx={{ p: 0 }}
          >
            <ArrowBackIcon
              sx={{
                color: "#053462",
                fontSize: "31px",
              }}
            />
          </IconButton>
        </Stack>
      )}

      <Stack
        justifyContent={"center"}
        alignItems={"center"}
        p={
          (phase === 1 && !notPossible) || phase === 4
            ? "72px 160px"
            : "41px 160px"
        }
      >
        {notPossible && <img src={WarningImage} alt="Warning" height="120px" />}

        <Typography
          color={notPossible ? "#EB2128" : "#053462"}
          fontSize={"32px"}
          fontWeight={800}
          mt={notPossible ? "32px" : ""}
        >
          {!notPossible
            ? phase === 4
              ? "Cadastro cancelado!"
              : "Cancelamento de cadastro"
            : "Não foi possível cancelar o cadastro deste imóvel"}
        </Typography>
        <Typography
          color="#636363"
          fontSize={"16px"}
          fontWeight={600}
          mt={"32px"}
          textAlign={"left"}
        >
          {!notPossible
            ? phase === 4
              ? "Seu cancelamento foi realizado com sucesso! O técnico responsável, irá realizar o procedimento de corte no local dentro da data prevista."
              : "Após o cancelamento de cadastro, o fornecimento de gás do imóvel abaixo será suspenso em até 3 dias úteis. Para concluir o processo, informe abaixo quando você deixará o imóvel ou a data prevista para a saída."
            : "O fornecimento de gás é interrompido em até 72 horas após o cancelamento de cadastro. Por isso, sugerimos que você realize o cancelamento apenas 3 dias úteis antes de deixar o imóvel, ou logo após a saída."}
        </Typography>

        {phase === 4 && (
          <>
            <Typography
              color="#636363"
              fontSize={"16px"}
              fontWeight={600}
              mt={"20px"}
              textAlign={"left"}
            >
              Um protocolo foi gerado com todas as informações do processo e
              estará disponível para consulta a qualquer momento na aba
              Protocolos, dentro da seção Serviços.
            </Typography>
            <Typography
              fontSize={"25px"}
              fontWeight={700}
              mt={"20px"}
              textAlign={"left"}
              color="#01C4FE"
            >
              {occurrence["v-nr-ocorrencia"]}
            </Typography>
          </>
        )}

        {notPossible && (
          <Typography
            color="#636363"
            fontSize={"16px"}
            fontWeight={600}
            mt={"25px"}
            textAlign={"left"}
            width={"100%"}
          >
            Não se preocupe! podemos te enviar um lembrete para te lembrar no
            momento certo.
          </Typography>
        )}
        {phase !== 4 ? (
          <Stack
            borderRadius={"8px"}
            border={"2px solid #EB2128"}
            mt={"50px"}
            p={"0px 24px"}
            alignItems={"center"}
            direction={"row"}
            width={"94%"}
            justifyContent={"space-between"}
            height={"158px"}
          >
            <IconHome size={60} />
            <Typography
              color="#636363"
              fontSize={"18px"}
              fontWeight={500}
              width={"50%"}
              textAlign={"left"}
            >
              {address.endereco}, {address.bairro} - {address.cidade}
            </Typography>
            <IconButton
              onClick={() => history.push("/address-list")}
              sx={{
                borderRadius: "50%",
                border: "2px solid #EB2128",
                color: "#EB2128",
              }}
              width={"33%"}
            >
              <IconClose size={25} />
            </IconButton>
          </Stack>
        ) : null}

        <Stack
          mt={"50px"}
          width={"70%"}
          justifyContent={"center"}
          textAlign={"left"}
        >
          {phase === 1 && !notPossible && (
            <>
              <Typography
                fontSize="22px"
                fontWeight={600}
                color="#053462"
                mb={"13px"}
              >
                Quando sairá do imóvel?
              </Typography>
              <RadioButtons
                value={itsOut}
                onChange={setItsOut}
                options={[
                  { value: "YES", label: "Já saí do imóvel" },
                  { value: "NO", label: "Sairei do imóvel no dia:" },
                ]}
              />
              <DatePicker
                disablePast
                value={itsOutDate ? itsOutDate : null}
                onChange={(newValue) => setItsOutDate(newValue)}
                slotProps={{
                  textField: { variant: "standard" },
                }}
                sx={{ mt: "16px" }}
                disabled={itsOut === "YES" || itsOut === ""}
              />
            </>
          )}
          {phase === 2 && (
            <>
              <Typography
                fontSize="18px"
                fontWeight={600}
                color="#053462"
                mb={"13px"}
              >
                Seu condomínio tem porteiro?
              </Typography>
              <RadioButtons
                value={hasDoorman}
                onChange={setHasDoorman}
                options={[
                  { value: "YES", label: "Sim" },
                  { value: "NO", label: "Não" },
                ]}
              />
              {hasDoorman === "NO" && (
                <>
                  <Typography fontSize="16px" fontWeight={600} color="#636363">
                    Mesmo sem a presença de um porteiro, o técnico ainda
                    precisará acessar o local para realizar o corte de
                    fornecimento. Por isso, informe a seguir de que forma esse
                    acesso será feito.
                  </Typography>
                  <Stack justifyContent="space-between" mt={"40px"}>
                    <Typography
                      fontSize="18px"
                      fontWeight={600}
                      color="#053462"
                      mb={"13px"}
                    >
                      Como o técnico poderá acessar o local para realizar o
                      atendimento?
                    </Typography>
                    <RadioButtons
                      value={enterQuestion}
                      onChange={setEnterQuestion}
                      options={[
                        {
                          value: "me",
                          label: "Estarei no local para receber o técnico",
                        },
                        {
                          value: "anotherPerson",
                          label:
                            "Outra pessoa estará no local para receber o técnico",
                        },
                        { value: "others", label: "Outras formas de acesso" },
                      ]}
                    />
                    {enterQuestion === "others" && (
                      <>
                        <Typography
                          fontSize="16px"
                          fontWeight={600}
                          color="#636363"
                        >
                          Use o campo abaixo para detalhar como o técnico poderá
                          acessar o local no dia do atendimento:
                        </Typography>

                        <TextField
                          placeholder="Portão estará aberto, chave estará com vizinho, portão com código de acesso, etc."
                          multiline
                          value={othersAccess}
                          onChange={(e) => {
                            setOthersAccess(e.target.value);
                          }}
                          rows={6}
                          sx={{
                            mt: "8px",
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: "#9F9F9F",
                                background: "#63636326",
                              },

                              padding: "10px",
                              fontSize: "12px",
                              "&.Mui-focused": {
                                "& fieldset": {
                                  borderColor: "#9F9F9F",
                                  borderWidth: 2,
                                },
                              },

                              "& textarea::placeholder": {
                                fontSize: "12px",
                                fontStyle: "italic",
                              },
                            },
                          }}
                        />
                      </>
                    )}
                    {enterQuestion === "anotherPerson" && (
                      <>
                        <Typography
                          fontSize="16px"
                          fontWeight={600}
                          color="#636363"
                        >
                          Confirme os dados de contato da pessoa que irá receber
                          o técnico no dia do atendimento. Essas informações
                          estarão disponíveis na ordem de serviço, na aba de
                          protocolos.
                        </Typography>
                        <TextField
                          variant="standard"
                          placeholder="Nome completo"
                          color="secondary"
                          value={name}
                          onChange={(e) => {
                            setName(e.target.value);
                          }}
                          sx={{
                            mt: "12px",
                          }}
                        />
                        <TextField
                          placeholder="Telefone"
                          variant="standard"
                          color="secondary"
                          value={phone}
                          onChange={(e) => {
                            const value = maskPhoneNumber(e.target.value);
                            setPhone(value);
                          }}
                          sx={{
                            mt: "28px",
                          }}
                        />
                      </>
                    )}
                  </Stack>
                </>
              )}
            </>
          )}
          {phase === 3 && (
            <>
              <Stack textAlign={"center"}>
                <Typography color="#053462" fontWeight={600} fontSize={"22px"}>
                  Data que deixará imóvel:
                </Typography>
                <Typography
                  fontWeight={600}
                  fontSize={"36px"}
                  color="#01C4FE"
                  mt={"6px"}
                >
                  {dayjs(itsOutDate).format("DD/MM/YYYY")}
                </Typography>
              </Stack>
              <Stack textAlign={"center"} mt={"42px"}>
                <Typography color="#053462" fontWeight={600} fontSize={"22px"}>
                  Seu condomínio tem porteiro?
                </Typography>
                <Typography
                  fontWeight={600}
                  fontSize={"36px"}
                  color="#01C4FE"
                  mt={"6px"}
                >
                  {hasDoorman === "YES" ? "Sim" : "Não"}
                </Typography>
              </Stack>

              {hasDoorman === "NO" && (
                <Stack textAlign={"center"} mt={"42px"}>
                  <Typography
                    color="#053462"
                    fontWeight={600}
                    fontSize={"22px"}
                  >
                    Como o técnico poderá acessar o local para realizar o
                    atendimento?
                  </Typography>
                  <Typography
                    fontWeight={600}
                    fontSize={"36px"}
                    color="#01C4FE"
                    mt={"6px"}
                    lineHeight={"100%"}
                  >
                    {enterQuestion === "others"
                      ? othersAccess
                      : enterQuestion === "me"
                      ? "Estarei no local para receber o técnico"
                      : "Outra pessoa estará no local para receber o técnico"}
                  </Typography>
                  {enterQuestion === "anotherPerson" && (
                    <>
                      <Typography
                        fontWeight={600}
                        fontSize={"36px"}
                        color="#01C4FE"
                        mt={"40px"}
                        lineHeight={"100%"}
                      >
                        {name}
                      </Typography>
                      <Typography
                        fontWeight={600}
                        fontSize={"36px"}
                        color="#01C4FE"
                        lineHeight={"100%"}
                      >
                        {phone}
                      </Typography>
                    </>
                  )}
                </Stack>
              )}
            </>
          )}
        </Stack>
        {phase !== 4 && (
          <Button
            variant="contained"
            color="secondary"
            disabled={!disableButton()}
            onClick={() => {
              const utilsDays = countBusinessDays(dayjs(), itsOutDate);

              if (notPossible) {
                return sendMail();
              }

              if (utilsDays > 3) {
                return setNotPossible(true);
              }

              if (phase < 3) {
                return setPhase((prev) => prev + 1);
              }

              return handleOrder();
            }}
            sx={{
              color: "#fff",
              height: "55px",
              width: "100%",
              borderRadius: "36px",
              mt: "77px",
            }}
          >
            {phase > 2
              ? "Confirmar"
              : notPossible
              ? "Quero receber lembrete"
              : "Avançar"}
          </Button>
        )}

        {notPossible && (
          <Button
            variant="outlined"
            color="secondary"
            disabled={!disableButton()}
            onClick={() => {
              history.push("/home");
            }}
            sx={{
              height: "55px",
              width: "100%",
              borderRadius: "36px",
              mt: "16px",
            }}
          >
            Voltar para home
          </Button>
        )}
        <ModalConfirmationEmail
          open={modalConfirmation}
          onClose={() => {
            setModalConfirmation(false);
            history.push("/address-list");
          }}
        />
      </Stack>
    </HomeTemplate>
  );
}
